export default __webpack_public_path__ + "static/media/icn_bigup.b821ae50.svg";